module.exports = __webpack_public_path__ + "img/img1.78708517.jpg";